/**
 * Caryn's newest message to the fan and how many of hers are still unread - for the Home "Your texts" card and the
 * menu dot. Counted from the fan's own recent messages (GET /api/messages/:conversationId), so nothing new is exposed.
 */
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { texts, type ChatMessage, type Conversation } from '~/api/endpoints'
import { useAuth } from '@/features/auth'

export function useUnread() {
  const { user } = useAuth()
  const { pathname } = useLocation()
  const [state, setState] = useState<{ loading: boolean; conversation: Conversation | null; latest: ChatMessage | null; unread: number }>({ loading: true, conversation: null, latest: null, unread: 0 })

  useEffect(() => {
    if (!user?.id) return
    let alive = true
    ;(async () => {
      const conv = await texts.conversation()
      if (!conv) { if (alive) setState({ loading: false, conversation: null, latest: null, unread: 0 }); return }
      const list = await texts.recent(conv.id, 50)
      const theirs = list.filter((m) => m.sender_id !== user.id)
      const unread = theirs.filter((m) => !m.read_at).length
      const latest = [...theirs].reverse().find((m) => (m.content || '').trim()) || null
      if (alive) setState({ loading: false, conversation: conv, latest, unread })
    })()
    return () => { alive = false }
  }, [user?.id, pathname])

  return state
}
